<template>
  <div class="calendar-online" v-if="localMeeting">
    <div class="type-calendar h-48"><h2>予約申請</h2></div>

    <SelectCategory v-model="localMeeting.category.id" v-if="currentStep === 'select-category'"/>

    <SetTitle v-model="localMeeting.title" v-show="currentStep === 'set-title'"/>

    <SelectPharmacies v-model="localMeeting.pharmacy" v-show="currentStep === 'add-pharmacies'" :meeting="meeting"/>

    <TimePicker v-model="localMeeting.time" v-if="currentStep === 'time-picker'" :pharmacy="localMeeting.pharmacy" :oldPharmacy="meeting.pharmacy" :meeting="localMeeting"/>

    <Confirm v-if="currentStep === 'confirm'" :meeting="meeting" :localMeeting="localMeeting"/>

    <LastStep v-show="currentStep === 'last-step'"
      :meeting-category="localMeeting.category.id"
      :meeting="meeting"
      :meeting-id="meetingId" />

    <Buttons :current-step="currentStep" :steps="steps" @changeStep="changeStep" :meeting="meeting" :selectedPharmacy="localMeeting.pharmacy"/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import _ from 'lodash'
import MeetingsApi from '@/api/meeting'
import Calendar from '@/components/Calendar'
import SelectCategory from '@/components/meetings/create/SelectCategory'
import SetTitle from '@/components/meetings/create/SetTitle'
import SelectPharmacies from '@/components/meetings/create/SelectPharmacies'
import TimePicker from '@/components/meetings/create/TimePicker'
import Confirm from '@/components/meetings/create/Confirm'
import LastStep from '@/components/meetings/create/LastStep'
import Buttons from '@/components/meetings/create/Buttons'
import {apiErrorDialog} from '@/helpers'

export default {
  components: {
    Calendar,
    SelectCategory,
    SelectPharmacies,
    TimePicker,
    Confirm,
    LastStep,
    Buttons,
    SetTitle
  },
  props: {
    meeting: {type: Object, required: true}
  },
  watch: {
  },
  data () {
    return {
      localMeeting: null,
      currentStep: 'select-category',
      steps: ['select-category', 'set-title', 'add-pharmacies', 'time-picker', 'confirm', 'last-step'],
      meetingId: -1,
      meeting: {},
    }
  },
  computed: {
    ...mapGetters({
      meetingCategoroies: 'meetings/categories'
    })
  },
  methods: {
    showErrorMessage (msg) {
      this.$message.error(msg)
    },
    async changeStep (step, back = false) {
      if (!back) {
        if (this.currentStep === 'select-category') {
          if (!this.localMeeting.category) {
            this.showErrorMessage('薬局を選択してください')
            return false
          }
        } else if (this.currentStep === 'add-pharmacies') {
          if (!this.localMeeting.pharmacy) {
            this.showErrorMessage('薬局を選択してください')
            return false
          }
        } else if (this.currentStep === 'time-picker') {
          if (!this.localMeeting.time.start || !this.localMeeting.time.end) {
            this.showErrorMessage('日程を選択してください')
            return false
          }
        } else if (this.currentStep === 'confirm') {
          await this.updateMeeting()
        } else if (this.currentStep === 'last-step') {
          return this.$router.push({name: 'home'})
        }
      }
      this.currentStep = step
    },
    async updateMeeting () {
      const loading = this.$loading.show()

      try {
        let meeting = {}
        meeting.title = this.localMeeting.title
        meeting.category_id = this.localMeeting.category.id
        meeting.pharmacy_id = this.localMeeting.pharmacy.id
        meeting.start_at = this.localMeeting.time.start.format('Y-MM-DD HH:mm:00')
        meeting.end_at = this.localMeeting.time.end.format('Y-MM-DD HH:mm:00')
        const updatedMeeting = await MeetingsApi.update(this.localMeeting.id, meeting)
          .catch((error) => {
            loading.hide()
            apiErrorDialog(this, error)
          })
        if (meeting.category_id === 1) {
          this.meetingId = updatedMeeting.data.data.id
          this.meeting = updatedMeeting.data.data
        }
      } catch (e) {
        console.log(e)
      }

      loading.hide()
    }
  },
  mounted () {
    this.localMeeting = _.cloneDeep(this.meeting)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Meeting/MedicationInstruction/Update.vue